import { tryCatch } from '@thalesrc/js-utils';

import HSApi from '../HSApi';
import { GetPpeDefinitionResult } from './get-ppe-definition.result';

export async function GetPpeDefinition(): Promise<GetPpeDefinitionResult[]> {
  const [error, res] = await tryCatch(HSApi.get<GetPpeDefinitionResult[]>(`/ppe-definitions?page=0&size=100000`));

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }

  return res.data.content;
}
